import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=d962d9fe&scoped=true&"
import script from "./notifications.vue?vue&type=script&lang=js&"
export * from "./notifications.vue?vue&type=script&lang=js&"
import style0 from "../less/profileSettings.less?vue&type=style&index=0&id=d962d9fe&scoped=true&lang=css&"
import style1 from "./notifications.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d962d9fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d962d9fe')) {
      api.createRecord('d962d9fe', component.options)
    } else {
      api.reload('d962d9fe', component.options)
    }
    module.hot.accept("./notifications.vue?vue&type=template&id=d962d9fe&scoped=true&", function () {
      api.rerender('d962d9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/pages/notifications.vue"
export default component.exports